export default "https://cdn-static-staging.gokick.com/assets/8452366be4f72804419de7522b15e5b20c0c8dd8/images/citrus-zen.3d089e3f253b955a4e1c4ecfa30a73d4.png";